import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { useUpdateEtudeDataJsonMutation } from "store/api";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
import { setEtudeData, setEtudeId } from "store/etudeSlice";
import { useCurrentEtudeData } from "./useCurrentEtudeData";
import { EtudeStep } from "utils/defines";

export const useEtudeUpdate = (siteName?: string, formData?: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { network } = useSalesNetwork();
  const { etudeData } = useCurrentEtudeData();
  const { etudeId, etudeType } = useParams();
  const params = useParams();

  const [
    updateEtudeDataJson,
    { isSuccess: isSuccessEtudeJsonSave, isLoading: isLoadingEtudeJsonSave },
  ] = useUpdateEtudeDataJsonMutation();

  const handleUpdateJson = async () => {
    const etudeUpdateData = {
      id: etudeId && !isNaN(+etudeId) ? +etudeId : 0,
      name: siteName || etudeData?.siteName,
      code: network?.code,
      jsonData: JSON.stringify(formData),
    };

    await updateEtudeDataJson({ ...etudeUpdateData }).then((result: any) => {
      if (result.error) {
        throw new Error(result.error.data.title);
      }

      const step = JSON.parse(result.data?.json).step;
      const detailUrlEncoded = encodeURIComponent(params.selectedDetail ?? "");
      let path = "";
      if (etudeId) {
        switch (step) {
          case EtudeStep.InputForm:
            path = `/${params.network}/etude/${etudeType}/${result.data?.id}`;
            break;
          case EtudeStep.Solutions:
            path = `/${params.network}/etude/${etudeType}/${result.data?.id}/solutions`;
            break;
          case EtudeStep.SolutionDetails:
            path = `/${params.network}/etude/${etudeType}/${result.data?.id}/solutions/${detailUrlEncoded}`;
            break;
          case EtudeStep.Accessoires:
            path = `/${params.network}/etude/${etudeType}/${result.data?.id}/solutions/${detailUrlEncoded}/accessoires`;
            break;
          case EtudeStep.Documents:
            path = `/${params.network}/etude/${etudeType}/${result.data?.id}/documents`;
            break;
        }
      }

      dispatch(setEtudeId(result?.data?.id));
      dispatch(
        setEtudeData({
          ...result?.data,
          etudeId: result?.data?.id,
        })
      );
      navigate(path, {
        replace: true,
      });
    });
  };

  const navigateToAccessoires = (selectedDetail: string | undefined) =>
  {
      const detailUrlEncoded = encodeURIComponent(selectedDetail ?? "");
      const path = `/${params.network}/etude/${etudeType}/${etudeId}/solutions/${detailUrlEncoded}/accessoires`;
      navigate(path, {
        replace: true,
      });
  }

  return {
    handleUpdateJson,
    navigateToAccessoires,
    isLoadingEtudeJsonSave,
    isSuccessEtudeJsonSave,
  };
};
